import * as React from 'react';
import { IconProps } from '../types';

const IcChevronLeft = (props:IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_248_14988)">
      <path
        fill={props?.fill ?? '#232F3E'}
        d="M16.5 3c.3 0 .5.1.7.3.4.4.4 1 0 1.4L9.9 12l7.3 7.3c.4.4.4 1 0 1.4-.4.4-1 .4-1.4 0l-8-8c-.4-.4-.4-1 0-1.4l8-8c.2-.2.4-.3.7-.3Z"
      />
    </g>
    <defs>
      <clipPath id="clip0_248_14988">
        <rect width={24} height={24} fill="#fff" transform="translate(.5)" />
      </clipPath>
    </defs>
  </svg>
);

export default IcChevronLeft;